module.exports = __webpack_public_path__ + "static/media/logo182.d6f22954.png";